export interface SelectPlansData {
  planoPai: string;
  nome: string;
  codigo: string;
  rede: string;
  plano: string;
  registroAns: string;
  codigo_envio: string;
  plano_desc: string;
  patrocinadora?: string;
  categoria?: string;
  abrangencia?: string;
  rede_essencial?: string;
}

export const selectPlansData: Array<SelectPlansData> = [
  {
    planoPai: 'Digna Saúde',
    nome: 'AES BRASIL - Digna Saúde – AMH/AO – Prata II',
    codigo: 'DIGNA_PRATA_II_AES_BRASIL',
    rede: 'Assistência Odontológica',
    plano: '77',
    registroAns: '43243400-0',
    codigo_envio: 'AO_DIGNA_PRATA_II',
    plano_desc: '91',
    patrocinadora: 'AES BRASIL',
    categoria: 'AMH/AO – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'AES BRASIL - Digna Saúde – AMH/AO – Ouro II',
    codigo: 'DIGNA_OURO_II_AES_BRASIL',
    rede: 'Assistência Odontológica',
    plano: '81',
    registroAns: '49124022-3',
    codigo_envio: 'AO_DIGNA_OURO_II',
    plano_desc: null,
    patrocinadora: 'AES BRASIL',
    categoria: 'AMH/AO – OURO II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'CESP - Digna Saúde – AMH – Prata III',
    codigo: 'DIGNA_PRATA_III_CESP',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '43242600-9',
    codigo_envio: 'AO_DIGNA_PRATA_III',
    plano_desc: '118',
    patrocinadora: 'CESP',
    categoria: 'AMH – Prata III',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'CPFL - Digna Saúde – AMH/AO – Prata II',
    codigo: 'DIGNA_PRATA_II_CPFL',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '43242700-7',
    codigo_envio: 'AO_DIGNA_PRATA_II',
    plano_desc: '77',
    patrocinadora: 'CPFL',
    categoria: 'AMH/AO – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'CPFL - Digna Saúde – AMH/AO – Ouro II',
    codigo: 'DIGNA_OURO_II_CPFL',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '46699012-8',
    codigo_envio: 'AO_DIGNA_OURO_II',
    plano_desc: '100',
    patrocinadora: 'CPFL',
    categoria: 'AMH/AO – Ouro II',
    abrangencia: null,
  },
  {
    planoPai: 'Cristal Odonto',
    nome: 'CPFL - Digna Saúde – AO – Cristal',
    codigo: 'DIGNA_CRISTAL_CPFL',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '46698612-0',
    codigo_envio: 'AO_DIGNA_CRISTAL',
    plano_desc: null,
    patrocinadora: 'CPFL',
    categoria: 'AO – Cristal',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'ISA CTEEP - Digna Saúde – AMH/AO – Prata I',
    codigo: 'DIGNA_PRATA_I_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '46698012-1',
    codigo_envio: 'AO_DIGNA_PRATA_II',
    plano_desc: '70',
    patrocinadora: 'ISA CTEEP',
    categoria: 'AMH/AO – Prata I',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'ISA CTEEP - Digna Saúde – AMH/AO – Prata II',
    codigo: 'DIGNA_PRATA_II_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '43243300-1',
    codigo_envio: 'AO_DIGNA_PRATA_II',
    plano_desc: '90',
    patrocinadora: 'ISA CTEEP',
    categoria: 'AMH/AO – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'ISA CTEEP - Digna Saúde – AMH/AO – Ouro II',
    codigo: 'DIGNA_OURO_II_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '81',
    registroAns: '46698512-1',
    codigo_envio: 'AO_DIGNA_OURO_II',
    plano_desc: '101',
    patrocinadora: 'ISA CTEEP',
    categoria: 'AMH/AO – Ouro II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'Paranapanema - Digna Saúde – AMH/AO – Prata II',
    codigo: 'DIGNA_PRATA_II_DUKE',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '43243500-8',
    codigo_envio: 'AO_DIGNA_PRATA_II',
    plano_desc: '92',
    patrocinadora: 'Paranapanema',
    categoria: 'AMH/AO – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Digna Saúde',
    nome: 'EMAE - Digna Saúde – AMH/AO – Prata III',
    codigo: 'DIGNA_PRATA_III_EMAE',
    rede: 'Assistência Odontológica',
    plano: '79',
    registroAns: '43243200-3',
    codigo_envio: 'AO_DIGNA_PRATA_III',
    plano_desc: '68',
    patrocinadora: 'EMAE',
    categoria: 'AMH/AO – Prata III',
    abrangencia: null,
  },
  {
    planoPai: 'Cristal Odonto',
    nome: 'Vivest - Digna Saúde - AO - CRISTAL',
    codigo: 'DIGNA_CRISTAL_FUNCESP',
    rede: 'Assistência Odontológica',
    plano: '179',
    registroAns: '46699112-6',
    codigo_envio: 'AO_DIGNA_CRISTAL',
    plano_desc: null,
    patrocinadora: 'Vivest',
    categoria: 'AO - CRISTAL',
    abrangencia: null,
  },
  {
    planoPai: 'Cristal Odonto',
    nome: 'ISA CTEEP - CRISTAL A',
    codigo: 'CRISTAL_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '277',
    registroAns: '499171241',
    codigo_envio: 'AO_DIGNA_CRISTAL',
    plano_desc: null,
    patrocinadora: 'ISA CTEEP',
    categoria: 'AO - CRISTAL',
    abrangencia: null,
  },
  {
    planoPai: 'Cristal Odonto',
    nome: 'ISA CTEEP - CRISTAL B',
    codigo: 'CRISTAL_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '278',
    registroAns: '499172249',
    codigo_envio: 'AO_DIGNA_CRISTAL',
    plano_desc: null,
    patrocinadora: 'ISA CTEEP',
    categoria: 'AO - CRISTAL',
    abrangencia: null,
  },
  {
    planoPai: 'Cristal Odonto',
    nome: 'ISA CTEEP - CRISTAL C',
    codigo: 'CRISTAL_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '279',
    registroAns: '499173247',
    codigo_envio: 'AO_DIGNA_CRISTAL',
    plano_desc: null,
    patrocinadora: 'ISA CTEEP',
    categoria: 'AO - CRISTAL',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'AES BRASIL - Extensive Saúde – Prata II',
    codigo: 'EXTENSIVE_PRATA_II_AES_BRASIL',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46692312-1',
    codigo_envio: 'AO_EXTENSIVE_PRATA2',
    plano_desc: '104',
    patrocinadora: 'AES BRASIL',
    categoria: 'Saúde – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'AES BRASIL - Extensive Saúde – Ouro II',
    codigo: 'EXTENSIVE_OURO_II_AES_BRASIL',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '49124122-1',
    codigo_envio: 'AO_EXTENSIVE_OURO2',
    plano_desc: null,
    patrocinadora: 'AES BRASIL',
    categoria: 'Saúde – OURO II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'CESP - Extensive Saúde – Prata III',
    codigo: 'EXTENSIVE_PRATA_III_CESP',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46692912-1',
    codigo_envio: 'AO_EXTENSIVE_PRATA3',
    plano_desc: '114',
    patrocinadora: 'CESP',
    categoria: 'Saúde – Prata III',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'CPFL - Extensive Saúde – Prata II',
    codigo: 'EXTENSIVE_PRATA_II_CPFL',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46692412-0',
    codigo_envio: 'AO_EXTENSIVE_PRATA2',
    plano_desc: '105',
    patrocinadora: 'CPFL',
    categoria: 'Saúde – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'CPFL - Extensive Saúde – Ouro II',
    codigo: 'EXTENSIVE_OURO_II_CPFL',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46693412-7',
    codigo_envio: 'AO_EXTENSIVE_OURO2',
    plano_desc: '111',
    patrocinadora: 'CPFL',
    categoria: 'Saúde – Ouro II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'ISA CTEEP - Extensive Saúde – Prata II',
    codigo: 'EXTENSIVE_PRATA_II_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46692512-8',
    codigo_envio: 'AO_EXTENSIVE_PRATA2',
    plano_desc: '106',
    patrocinadora: 'ISA CTEEP',
    categoria: 'Saúde – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'ISA CTEEP - Extensive Saúde – Ouro II',
    codigo: 'EXTENSIVE_OURO_II_CTEEP',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46692612-6',
    codigo_envio: 'AO_EXTENSIVE_OURO2',
    plano_desc: '112',
    patrocinadora: 'ISA CTEEP',
    categoria: 'Saúde – Ouro II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'Paranapanema - Extensive Saúde – Prata II',
    codigo: 'EXTENSIVE_PRATA_II_DUKE',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46693512-5',
    codigo_envio: 'AO_EXTENSIVE_PRATA2',
    plano_desc: '107',
    patrocinadora: 'Paranapanema',
    categoria: 'Saúde – Prata II',
    abrangencia: null,
  },
  {
    planoPai: 'Extensive',
    nome: 'EMAE - Extensive Saúde – Prata III',
    codigo: 'EXTENSIVE_PRATA_III_EMAE',
    rede: 'Assistência Odontológica',
    plano: '75',
    registroAns: '46693012-4',
    codigo_envio: 'AO_EXTENSIVE_PRATA3',
    plano_desc: '115',
    patrocinadora: 'EMAE',
    categoria: 'Saúde – Prata III',
    abrangencia: null,
  },
];
